<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :value="create"
    max-width="600px"
    retain-focus
    v-on:click:outside="$router.push('/supplier')"
    v-on:keydown.esc="$router.push('/supplier')"
  >
    <v-card>
      <v-overlay absolute :value="this.loading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-overlay>
      <v-card-title tabindex="-1">
        <span class="headline">Create Supplier</span>
        <v-btn
          style="position: absolute; top: 0; right: 0;"
          @click="
            () => {
              this['Supplier/fetchSuppliers']({ page: this.page });
              $router.push('/supplier');
            }
          "
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form width="100%" ref="createForm" v-model="createValid">
          <v-text-field
            label="Company Name*"
            v-model="createFields.company_name"
            :rules="validationRules.company_name"
            :error-messages="inputErrorMessages('company_name')"
            @keyup.enter="saveSupplier"
            name="company_name"
          ></v-text-field>
          <v-text-field
            label="Contact Person"
            v-model="createFields.contact_person"
            :rules="validationRules.contact_person"
            :error-messages="inputErrorMessages('contact_person')"
            name="contact_person"
          ></v-text-field>
          <v-text-field
            label="Email Address*"
            v-model="createFields.email_address"
            :rules="validationRules.email_address"
            :error-messages="inputErrorMessages('email_address')"
            name="email_address"
          ></v-text-field>
          <v-text-field
            label="Contact Numbers*"
            v-model="createFields.contact_number"
            :rules="validationRules.contact_number"
            :error-messages="inputErrorMessages('contact_number')"
            name="contact_number"
          ></v-text-field>
          <v-text-field
            label="Address"
            v-model="createFields.address"
            :rules="validationRules.address"
            :error-messages="inputErrorMessages('address')"
            name="address"
          ></v-text-field>
          <v-text-field
            label="Web Address"
            v-model="createFields.web_address"
            :rules="validationRules.web_address"
            :error-messages="inputErrorMessages('web_address')"
            name="web_address"
          ></v-text-field>
          <v-text-field
            label="Supplier Code*"
            v-model="createFields.supplier_code"
            :rules="validationRules.supplier_code"
            :error-messages="inputErrorMessages('supplier_code')"
            name="supplier_code"
          ></v-text-field>
        </v-form>
        <small>* indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="
            $router.push('/supplier');
            clearCreate();
          "
          >Cancel</v-btn
        >
        <v-btn color="blue darken-1" text @click="saveSupplier">Save</v-btn>
        <v-switch v-model="continousCreation" label="Continuous Create"></v-switch>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data: function() {
    return {
      loading: false,
      continousCreation: false,
      createValid: true,
      validationRules: {
        company_name: [
          v => !!v || this.rem('Company name'),
          v => v.length <= 255 || 'Company name should not be greater than 255'
        ],
        contact_person: [v => v.length <= 255 || 'Contact person should not be greater than 255'],
        email_address: [
          v => !!v || this.rem('Email address'),
          v => v.length <= 255 || 'Email address should not be greater than 255',
          v => !v || /.+@.+/.test(v) || 'Email address must be valid'
        ],
        contact_number: [
          v => !!v || this.rem('Contact number'),
          v => v.length <= 255 || 'Contact numbers should not be greater than 255'
        ],
        address: [v => v.length <= 255 || 'Address should not be greater than 255'],
        web_address: [v => v.length <= 255 || 'Web address should not be greater than 100'],
        supplier_code: [
          v => !!v || this.rem('Supplier code'),
          v => v.length <= 255 || 'Company name should not be greater than 50'
        ]
      },
      errorMessages: {},
      createFields: {
        company_name: '',
        contact_person: '',
        email_address: '',
        contact_number: '',
        address: '',
        web_address: '',
        supplier_code: ''
      }
    };
  },
  props: {
    create: false,
    page: 0
  },
  methods: {
    ...mapActions(['Supplier/fetchSuppliers']),
    clearCreate() {
      this.createFields = {
        company_name: '',
        contact_person: '',
        email_address: '',
        contact_number: '',
        address: '',
        web_address: '',
        supplier_code: ''
      };
      this.$refs.createForm.resetValidation();
    },
    rem(name) {
      return `${name} is required`;
    },
    inputErrorMessages(input) {
      return this.errorMessages[input];
    },
    saveSupplier() {
      if (this.$refs.createForm.validate()) {
        this.loading = true;
        axios
          .post('api/v1/supplier', this.createFields)
          .then(response => {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'Supplier created successfully...',
              color: 'success'
            });
            this.errorMessages = [];
            this.$refs.createForm.resetValidation();
            this['Supplier/fetchSuppliers']({ page: this.page });
            this.clearCreate();
            this.$refs.createForm.resetValidation();
            if (this.continousCreation === false) {
              this.$router.push('/supplier');
            }
          })
          .catch(error => {
            if (error.response.status == 403) {
              this.$store.commit('SET_SNACK_BAR', {
                message: error.response.data['message'],
                color: 'error'
              });
            } else {
              this.errorMessages = error.response.data.errors;
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>